import { useState } from 'react';
import { Paper, Text, Button, Stack, Box } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';

export const PaymentCard = ({
  title,
  description,
  amountLabel,
  amount,
  amountDetails = '',
  amountColor = 'green',
  buttonText,
  buttonCaption,
  buttonIcon,
  onButtonClick,
  isDisabled = false,
  isLoading = false,
  hideButton = false,
  centerContent = false,
  compactMobile = false,
  embedded = false,
  children,
}) => {
  const textAlign = centerContent ? 'center' : 'start';
  const flexAlign = centerContent ? 'center' : 'flex-start';

  const [hovered, setHovered] = useState(false);

  const content = (
    <>
      <Box
        style={{
          minHeight: centerContent ? 'auto' : '170px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: centerContent ? 'flex-start' : 'space-between',
          alignItems: flexAlign,
        }}
      >
        <Stack gap={centerContent ? 2 : 4} align={centerContent ? 'center' : 'stretch'} w="100%">
          <Box
            style={{
              minHeight: centerContent ? 'auto' : '64px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: flexAlign,
              width: '100%',
            }}
          >
            <Text size={compactMobile ? 'sm' : 'md'} fw={600} ta={textAlign} w="100%">
              {title}
            </Text>
            {description && (
              <Text
                size={compactMobile ? 'xs' : 'sm'}
                c="#5a5a5a"
                mb={centerContent ? (compactMobile ? 2 : 4) : 8}
                ta={textAlign}
                w="100%"
                lineClamp={compactMobile ? 2 : undefined}
              >
                {description}
              </Text>
            )}
          </Box>
          {amount && (
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: flexAlign,
                minHeight: centerContent ? 'auto' : '88px',
                width: '100%',
              }}
            >
              <Text size="xs" c="dimmed" fw={500} ta={textAlign}>
                {amountLabel}
              </Text>
              <Text c={amountColor} fw={750} ta={textAlign} size={compactMobile ? '1.35em' : '1.7em'}>
                {amount} {amountDetails && <Text span c="dimmed" size="md">{amountDetails}</Text>}
              </Text>
            </Box>
          )}
        </Stack>
      </Box>

      {!hideButton && (
        <Stack gap={compactMobile ? 6 : 6} mt={centerContent ? (compactMobile ? 8 : 'xs') : 'md'} w="100%" align="stretch">
          <Button
            className="btn-with-gradient"
            fullWidth
            size={compactMobile ? 'sm' : 'md'}
            onClick={onButtonClick}
            disabled={isDisabled || isLoading}
            loading={isLoading}
            rightSection={buttonIcon || <IconArrowRight size={compactMobile ? 18 : 20} />}
          >
            {buttonText}
          </Button>
          {buttonCaption && (
            <Text size={compactMobile ? '10px' : 'xs'} c="dimmed" ta="center" lh={compactMobile ? 1.25 : undefined}>
              {buttonCaption}
            </Text>
          )}
        </Stack>
      )}

      {children && (
        <Box mt={4} style={{ display: 'flex', justifyContent: 'center' }}>
          {children}
        </Box>
      )}
    </>
  );

  if (embedded) {
    return <Box w="100%">{content}</Box>;
  }

  return (
    <Paper
      shadow={compactMobile ? 'xs' : 'md'}
      radius="md"
      p={compactMobile ? 'sm' : 'md'}
      withBorder={!compactMobile}
      mih={compactMobile ? 'auto' : '8rem'}
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: '4px',
        transition: compactMobile ? undefined : 'transform 0.30s cubic-bezier(.4,2,.6,1)',
        transform: !compactMobile && hovered ? 'scale(1.03)' : 'scale(1)',
        zIndex: !compactMobile && hovered ? 2 : 1,
      }}
      onMouseEnter={() => !compactMobile && setHovered(true)}
      onMouseLeave={() => !compactMobile && setHovered(false)}
    >
      {content}
    </Paper>
  );
}

export default PaymentCard;